import { STATS_COLUMNS_FOR_CATEGORY } from '../../../../common/config/columns';

export const composeColumnData = (seasonNavId, category) => {
    const resultHeader =
        seasonNavId !== -1
            ? [
                  {
                      Header: 'Result',
                      accessor: 'result',
                      disableSortBy: true
                  }
              ]
            : [];

    return [
        {
            Header: seasonNavId === -1 ? 'Year' : 'Round',
            accessor: seasonNavId === -1 ? 'year' : 'round',
            sortDescFirst: true
        },
        {
            Header: seasonNavId === -1 ? 'Club' : 'Opponent',
            accessor: seasonNavId === -1 ? 'club' : 'opponent',
            disableSortBy: true
        },
        ...resultHeader.map((col) => ({
            Header: col.Header,
            accessor: col.accessor,
            disableSortBy: true
        })),
        ...STATS_COLUMNS_FOR_CATEGORY[category].map((col) => ({
            Header: col.abbreviation,
            accessor: col.id,
            sortDescFirst: true
        }))
    ];
};
